import { CircularProgress, Grid } from '@material-ui/core';
import React, { Fragment } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../CoreNegocio.module.css';

const EvolutionTable = props => {
	const { empresas, reports, users, isLoading } = props;
	const gastos = reports;

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	let header;

	let nReports;
	let nGastos;
	let nGastosAprobados;
	let nGastosRechazados;

	let nEmpresas;
	let nUsuarios;
	let nUsuariosActivos;
	let nEmpresasActivas;

	if (isLoading === false) {
		header = users.map(element => (
			<Fragment key={element.initialDate}>
				<th colSpan="2">{formatDate(element.initialDate)}</th>
			</Fragment>
		));
		nEmpresas = empresas.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.nEmpresasNuevasActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeActive >= 0 ? classes.green : classes.red} key={'activos'}>
					<NumberFormat
						format={element.nEmpresasAnterior === 0 ? '-' : element.percentChangeActive}
						value={element.percentChangeActive}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nGastos = gastos.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.sumGastosActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeGastos >= 0 ? classes.green : classes.red} key={'gastos'}>
					<NumberFormat
						format={element.sumGastosAnterior === 0 ? '-' : element.percentChangeGastos}
						value={element.percentChangeGastos}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nGastosAprobados = gastos.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.sumGastosAprobadosActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeGastosAprobados >= 0 ? classes.green : classes.red} key={'aprobados'}>
					<NumberFormat
						format={element.sumGastosAprobadosAnterior === 0 ? '-' : element.percentChangeGastosAprobados}
						value={element.percentChangeGastosAprobados}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nGastosRechazados = gastos.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.sumGastosRechazadosActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeGastosRechazados >= 0 ? classes.green : classes.red} key={'aprobados'}>
					<NumberFormat
						format={element.sumGastosRechazadosAnterior === 0 ? '-' : element.percentChangeGastosRechazados}
						value={element.percentChangeGastosRechazados}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nReports = reports.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.nReportsActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeReports >= 0 ? classes.green : classes.red} key={'activos'}>
					<NumberFormat
						format={element.nReportsAnterior === 0 ? '-' : element.percentChangeReports}
						value={element.percentChangeReports}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nUsuarios = users.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.nUsuariosRegActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeReg >= 0 ? classes.green : classes.red} key={'activos'}>
					<NumberFormat
						format={element.nUsuariosRegAnterior === 0 ? '-' : element.percentChangeReg}
						value={element.percentChangeReg}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nUsuariosActivos = users.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.nUsuariosActivosActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeActive >= 0 ? classes.green : classes.red} key={'activos'}>
					<NumberFormat
						format={element.nUsuariosActivosAnterior === 0 ? '-' : element.percentChangeActive}
						value={element.percentChangeActive}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));

		nEmpresasActivas = users.map(element => (
			<Fragment key={element.initialDate}>
				<td>
					<NumberFormat value={element.nEmpresasActivasActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
				</td>
				<td className={element.percentChangeEmpresas >= 0 ? classes.green : classes.red} key={'activos'}>
					<NumberFormat
						format={element.nEmpresasActivasAnterior === 0 ? '-' : element.percentChangeEmpresas}
						value={element.percentChangeEmpresas}
						displayType={'text'}
						thousandSeparator={true}
						decimalScale={2}
						suffix={'%'}
					/>
				</td>
			</Fragment>
		));
	}

	return (
		<Fragment>
			<Grid item xs={12}>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<div className={classes.card}>
							{isLoading ? (
								<CircularProgress />
							) : (
								<div className={classes.div}>
									<table className={classes.table}>
										<tbody>
											<tr>
												<td></td>
												{header}
											</tr>
											<tr colSpan="2">
												<td>Reportes</td>
												{nReports}
											</tr>
											<tr colSpan="2">
												<td>Gastos</td>
												{nGastos}
											</tr>
											<tr colSpan="2">
												<td>Gastos Aprobados</td>
												{nGastosAprobados}
											</tr>
											<tr colSpan="2">
												<td>Gastos Rechazados</td>
												{nGastosRechazados}
											</tr>
											<tr colSpan="2">
												<td>Empresas Activas</td>
												{nEmpresasActivas}
											</tr>
											<tr colSpan="2">
												<td>Empresas Nuevas</td>
												{nEmpresas}
											</tr>
											<tr colSpan="2">
												<td>Usuarios Reg.</td>
												{nUsuarios}
											</tr>
											<tr colSpan="2">
												<td>Usuarios Act.</td>
												{nUsuariosActivos}
											</tr>
										</tbody>
									</table>
								</div>
							)}
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
};

export default React.memo(EvolutionTable);
